import { Tab as ReactBootstrapTab, Tabs as ReactBootstrapTabs } from 'react-bootstrap';

import 'css/src/components/common/ui/Tabs';

import React from 'react';
import classnames from 'classnames';
import type { SelectCallback } from '@restart/ui/types';

export enum TAB_SIZE {
    'SM' = 'sm',
    'MD' = 'md',
}

export enum TAB_TITLE_POSITION {
    START = 'justify-content-start',
    CENTER = 'justify-content-center',
    END = 'justify-content-end',
}

type TabsProps = {
    defaultActiveKey?: string;
    activeKey?: string;
    onSelect?: SelectCallback;
    children: React.JSX.Element[];
    className?: string;
    size?: TAB_SIZE;
    titlePosition?: TAB_TITLE_POSITION;
};
export const Tabs = React.memo(function Tabs({
    // for an uncontrolled set of tabs:
    defaultActiveKey,

    // for a controlled set of tabs:
    activeKey,
    onSelect,

    // other props:
    children,
    className,
    size = TAB_SIZE.MD,
    titlePosition = TAB_TITLE_POSITION.CENTER,
}: TabsProps) {
    return (
        <ReactBootstrapTabs
            defaultActiveKey={defaultActiveKey}
            activeKey={activeKey}
            onSelect={onSelect}
            className={classnames('lumen5-tabs d-flex', titlePosition, size, className)}
        >
            {children.map((child) => {
                if (!child) {
                    return;
                }
                const { className, ...childProps } = child.props;
                return (
                    <Tab
                        key={childProps.eventKey}
                        className={classnames(className, 'lumen5-tab-panel')}
                        {...childProps}
                    />
                );
            })}
        </ReactBootstrapTabs>
    );
});

type TabProps = {
    eventKey: string;
    title: React.ReactNode;
    children?: React.ReactNode;
    className?: string;
};

export const Tab = React.memo(function Tab({ eventKey, title, children, className }: TabProps) {
    return (
        <ReactBootstrapTab eventKey={eventKey} title={title} className={className}>
            {children}
        </ReactBootstrapTab>
    );
});
